// extracted by mini-css-extract-plugin
export default {"skeleton":"clientDetail_skeleton__+Byr7"};